"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityLog = void 0;

var ActivityLog =
/** @class */
function () {
  function ActivityLog(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - eventId
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  ActivityLog.prototype.ListEntriesForEvent = function (eventId, page, itemsPerPage) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('ActivityLog/UseCase/ListEntriesForEvent', {
      eventId: eventId,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param string - invitationId
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  ActivityLog.prototype.ListEntriesForInvitation = function (invitationId, page, itemsPerPage) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('ActivityLog/UseCase/ListEntriesForInvitation', {
      invitationId: invitationId,
      page: page,
      itemsPerPage: itemsPerPage
    });
  }; // Commands

  /**
   * @param string - eventId
   * @param string - action added|created|added-to-transaction|added-to-web-conference|added-to-world|updated-for-world|changed-role-for-world|changed-team-id-for-world|changed-title-for-world|check-in|interacted|email|removed|responded|updated|transferred
   * @param string - actionValue
   * @param number - actionTime
   * @param string? - invitationId
   * @param string? - userId
   * @param string? - actionUserId
   * @param string? - activityLogId
   * @return Promise|Observable|any
   */


  ActivityLog.prototype.CreateActivityLog = function (eventId, action, actionValue, actionTime, invitationId, userId, actionUserId, activityLogId) {
    if (invitationId === void 0) {
      invitationId = null;
    }

    if (userId === void 0) {
      userId = null;
    }

    if (actionUserId === void 0) {
      actionUserId = null;
    }

    if (activityLogId === void 0) {
      activityLogId = null;
    }

    return this.restClient.post('ActivityLog/UseCase/CreateActivityLog', {
      eventId: eventId,
      action: action,
      actionValue: actionValue,
      actionTime: actionTime,
      invitationId: invitationId,
      userId: userId,
      actionUserId: actionUserId,
      activityLogId: activityLogId
    });
  };
  /**
   * @param string - eventId
   * @param string - action added|created|added-to-transaction|added-to-web-conference|added-to-world|updated-for-world|changed-role-for-world|changed-team-id-for-world|changed-title-for-world|check-in|interacted|email|removed|responded|updated|transferred
   * @param string - actionValue
   * @param number - actionTime
   * @param string - content
   * @param string? - invitationId
   * @param string? - userId
   * @param string? - actionUserId
   * @param string? - activityLogId
   * @param string? - activityDetailId
   * @return Promise|Observable|any
   */


  ActivityLog.prototype.CreateActivityLogAndDetail = function (eventId, action, actionValue, actionTime, content, invitationId, userId, actionUserId, activityLogId, activityDetailId) {
    if (invitationId === void 0) {
      invitationId = null;
    }

    if (userId === void 0) {
      userId = null;
    }

    if (actionUserId === void 0) {
      actionUserId = null;
    }

    if (activityLogId === void 0) {
      activityLogId = null;
    }

    if (activityDetailId === void 0) {
      activityDetailId = null;
    }

    return this.restClient.post('ActivityLog/UseCase/CreateActivityLogAndDetail', {
      eventId: eventId,
      action: action,
      actionValue: actionValue,
      actionTime: actionTime,
      content: content,
      invitationId: invitationId,
      userId: userId,
      actionUserId: actionUserId,
      activityLogId: activityLogId,
      activityDetailId: activityDetailId
    });
  };

  return ActivityLog;
}();

exports.ActivityLog = ActivityLog;